<template>
  <div>
    <list
      row-key="GoodsId"
      ref="list"
      unit="商品档案"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="false"
      :show-toolbar="false"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="商品条码">
          <el-input size="mini" clearable v-model="params.BarCode" placeholder="请输入商品条码" />
        </el-form-item>
        <el-form-item label="商品编码">
          <el-input size="mini" clearable v-model="params.GoodsCode" placeholder="请输入商品编码" />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input size="mini" clearable v-model="params.Model" placeholder="请输入规格型号" />
        </el-form-item>
        <!-- <el-form-item label="供应商">
          <el-input size="mini" clearable v-model="params.SupplierId" placeholder="请选择供应商" />
        </el-form-item> -->
        <!-- <el-form-item label="商品类型">
          <el-select size="mini" v-model="params.GoodsType" placeholder="请选择商品类型" clearable>
            <el-option label="劳务" :value="1"></el-option>
            <el-option label="实物" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商品标签">
          <el-input size="mini" v-model="params.Tags" placeholder="请选择商品标签" clearable />
        </el-form-item>
        <el-form-item label="商品状态" v-if="showStatus">
          <el-select size="mini" v-model="params.Status" placeholder="请选择商品状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品属性">
          <el-checkbox v-model="params.IsSale">销售</el-checkbox>
          <el-checkbox v-model="params.IsPurchase">采购</el-checkbox>
          <el-checkbox v-model="params.IsSelf">自制</el-checkbox>
          <el-checkbox v-model="params.IsConsume">耗材</el-checkbox>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="BarCode" label="商品条码" min-width="130px" />
        <el-table-column prop="GoodsCode" label="商品编码" min-width="110px" />
        <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
        <el-table-column prop="Model" label="规格型号" min-width="100px" />
        <el-table-column prop="WholesalePrice" label="单价" />
        <el-table-column prop="ExistQuantity" label="现存量" />
        <el-table-column prop="AvailableQuantity" label="可用量" />
        <el-table-column label="商品属性" min-width="200px">
          <template slot-scope="{row}">
            <span v-if="row.IsSale">销售、</span>
            <span v-if="row.IsPurchase">采购、</span>
            <span v-if="row.IsSelf">自制、</span>
            <span v-if="row.IsConsume">耗材、</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="GoodsType" label="商品类型" min-width="80px" align="center">
          <template slot-scope="{row}">
            <span>{{row.GoodsType==0?'实物':'劳务'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="Status" label="状态" width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.Status==0" type="danger">停用</el-tag>
            <el-tag size="mini" v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/goods/goods").default,
      params: {
        BarCode: "", //条码
        GoodsCode: "", //编码
        GoodsName: "", //名称
        Model: "", //规格型号
        WholesalePrice: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>